import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'


export function CheckGroup( props )
{
    const items = props.items 

    const selected = props.selected 
    const setSelected = props.setSelected 

    const isChecked = ( uid ) => {
        return selected.includes(uid)
    }

    const toggle = ( checked, uid ) => {
        let d = structuredClone(selected)

        if( checked && ! d.includes(uid) )
        {
            d.push(uid)
            setSelected(d)
        }

        if( !checked )
        {
            d = d.filter( e => e != uid )
            setSelected(d)
        }
    }

    return (
        <div style={{width:'100%'}}>
            {items.map( (item,idx) => 
            <Form.Check label={item.name} checked={isChecked(item.uid)} 
                        onChange={ e => toggle(e.target.checked, item.uid)} 
            />
            )}
        </div>

    )
}
